import { Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

import type { Payment } from './types'

interface Props {
  payment: Payment
}

export const Amount = ({ payment }: Props) => {
  const {
    company: { locale },
  } = useCurrentSession()
  return (
    <Text.Normal size="200">
      {formattedAmount({
        amountCents: payment.amountCents || 0,
        currency: payment.currency,
        locale: locale || '',
      })}
    </Text.Normal>
  )
}
